import { useProgress } from '@onwardtravelsolutions/package-react/Hooks';
import { JSX, useEffect } from 'react';

type ProgressBarProps = {
    duration: number;
    ascending?: boolean;
    startImmediately?: boolean;
    paused?: boolean;
    onStart?: () => void;
    onComplete?: () => void;
};

export default function ProgressBar({
    duration,
    paused = false,
    ascending = true,
    onStart = () => {},
    onComplete = () => {},
}: ProgressBarProps): JSX.Element {
    const { percentage, start, pause } = useProgress(
        duration,
        !paused,
        onStart,
        onComplete,
    );

    useEffect(() => {
        paused ? pause() : start();
    }, [paused]);

    return (
        <div className='relative w-full h-2.5' role='progressbar'>
            <div className='absolute inset-0 bg-white opacity-50'></div>
            <div
                data-testid='progress-fill'
                className='top-0 bottom-0 left-0 absolute bg-white opacity-90 transition'
                style={{
                    width: `${ascending ? percentage : 100 - percentage}%`,
                }}
            ></div>
        </div>
    );
}
